"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DataI = void 0;
var roDescr_1 = require("./utils/roDescr.js");
var DataI = /** @class */ (function () {
    function DataI(I) {
        if (I === void 0) { I = 0; }
        I = BigInt(I);
        Object.defineProperties(this, {
            int: __assign({ value: I }, roDescr_1.roDescr)
        });
    }
    DataI.prototype.clone = function () {
        return new DataI(this.int);
    };
    DataI.prototype.toJson = function () {
        return { int: this.int.toString() };
    };
    DataI.prototype.toString = function () {
        return "I ".concat(this.int.toString());
    };
    return DataI;
}());
exports.DataI = DataI;
